let CSRFToken;
let headers;

document.addEventListener("DOMContentLoaded", function() {
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    // in test the csrf token is not generated and added to the page
    CSRFToken = metaTag && metaTag.getAttribute('content');

    headers ={
        'X-CSRF-Token': CSRFToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
});

export function destroy(endpoint) {
    return fetch(
        endpoint,
        {
            method: 'DELETE',
            headers
        }
    )
}

export function post(endpoint, body) {
    return fetch(
        endpoint,
        {
            method: 'POST',
            body,
            headers
        }
    )
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/PaymentCancellation/utils.js